import { Component, OnInit, Inject } from '@angular/core';
import { DialogBase } from 't4core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-insurance-info-dialog',
  templateUrl: './insurance-info-dialog.component.html',
  styleUrls: ['./insurance-info-dialog.component.css']
})
export class InsuranceInfoDialogComponent extends DialogBase implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<InsuranceInfoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super("InsuranceInfoDialogComponent");
    }

    ngOnInit(): void {
        this.loading = true;
        this.loading = false;
  }

    public agree() {
        this.dialogRef.close(true);
    }

    public cancel() {
        this.dialogRef.close(false);
    }

}
